import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { toggleProDialog } from '../../../store/userSubscription/duck';

class ProRequiredDialog extends React.PureComponent {
  close = isUpgrade => {
    const { proDialog, toggleProDialog, history } = this.props;
    toggleProDialog(false);
    if (proDialog.cb) proDialog.cb(isUpgrade, history);
  };

  render() {
    const { intl, history, proDialog } = this.props;
    return proDialog ? (
      <Dialog open={!!proDialog} fullWidth={true} onClose={() => this.close(false)} style={{ zIndex: 1500 }}>
        <DialogTitle>{intl.formatMessage({ id: 'pro-dialog-title' })}</DialogTitle>
        <DialogContent>
          {proDialog.customMessage && <Typography>{proDialog.customMessage}</Typography>}
          {/* `planMessageId` names the plan when it is not Pro (an Ultra-only tool),
              so a Pro member is not told the feature is "only for PRO members". */}
          <Typography>{intl.formatMessage({ id: proDialog.planMessageId || 'pro-dialog-msg' })}</Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => this.close(false)}>{intl.formatMessage({ id: 'Cancel' })}</Button>
          {/* `onUpgrade` / `upgradeLabelId` replace the default 升級 → /subscription
              for a feature that is opened by contacting us rather than by a plan
              the adviser can buy on that page (e.g. A.I. 智能助理, ClientV2). */}
          <Button
            color="primary"
            onClick={() => {
              this.close(true);
              if (proDialog.onUpgrade) proDialog.onUpgrade();
              else history.push('/subscription');
            }}
          >
            {intl.formatMessage({ id: proDialog.upgradeLabelId || 'upgrade' })}
          </Button>
        </DialogActions>
      </Dialog>
    ) : null;
  }
}

const container = connect(
  // Map state to props
  state => ({
    proDialog: state.userSubscription.proDialog
  }),
  // Map actions to props
  {
    toggleProDialog
  },
  // mergeProps
  null,
  // options
  {}
)(ProRequiredDialog);

export default injectIntl(container);
